<div *ngIf="kind; else spinner" [class]="{'fullscreen': fullcreen, 'graph-wrapper': true}"
    (click)="fullcreen = !fullcreen">
    <canvas #chartCanvas baseChart [colors]="kind.colors" [datasets]="kind.dataset(graph)" [labels]="kind.labels(graph)"
        [options]="kind.options" [chartType]="kind.chartType" [plugins]="kind.plugins"></canvas>
</div>
<ng-template #spinner>
    <mat-spinner class="alabia-view-spinner"></mat-spinner>
</ng-template>